export const FETCH_BRAND_IMAGES = 'FETCH_BRAND_IMAGES';
export const FETCH_BRAND_IMAGE = 'FETCH_BRAND_IMAGE';
export const SET_BRAND_IMAGES = 'SET_BRAND_IMAGES';
export const ADD_BRAND_IMAGES = 'ADD_BRAND_IMAGES';
export const ADD_SUCCESS_BRAND_IMAGES = 'ADD_SUCCESS_BRAND_IMAGES';
export const UPDATE_BRAND_IMAGES = 'UPDATE_BRAND_IMAGES';
export const FETCH_BRAND_VEHICLES = 'FETCH_BRAND_VEHICLES';
export const FETCH_BRAND_VEHICLESCHROMEDATA = 'FETCH_BRAND_VEHICLESCHROMEDATA';
export const FETCH_BRAND_LOGOS = 'FETCH_BRAND_LOGOS';
export const FETCH_BRAND_IMAGES_OEM = 'FETCH_BRAND_IMAGES_OEM';
export const FETCH_BRAND_IMAGES_FILTERS = 'FETCH_BRAND_IMAGES_FILTERS';
export const SET_BRAND_IMAGES_FILTERS = 'SET_BRAND_IMAGES_FILTERS';
export const GET_EXTERNAL_IMAGE = 'GET_EXTERNAL_IMAGE';
export const SET_FETCH_BRAND_IMAGES = 'SET_FETCH_BRAND_IMAGES';
export const SET_FETCH_BRAND_IMAGES_SEARCH = 'SET_FETCH_BRAND_IMAGES_SEARCH';
export const SET_FETCH_BRAND_IMAGES_SECTION = 'SET_FETCH_BRAND_IMAGES_SECTION';
export const FETCH_COUNTER_BRAND_IMAGES = 'FETCH_COUNTER_BRAND_IMAGES';
export const SET_COUNTER_BRAND_IMAGES = 'SET_COUNTER_BRAND_IMAGES';
export const SET_COUNTER_BRAND_IMAGES_SEARCH = 'SET_COUNTER_BRAND_IMAGES_SEARCH';